import { FC } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { useAction, useAtom } from '@reatom/npm-react';
import { Button } from '@whitesharx/starfall-frontend-ui-kit';
import { hasVIP, useModal, usePlayerQuery, useServices } from '@whitesharx/starfall-frontend-core';

import AnalysisLimitModal from '../modals/AnalysisLimitModal';

import { TAP_EVENTS } from '~/src/services/analytics/contants';

import {
  analysisStartDateAction,
  analyzeGameAction,
  cgApiAtom,
  analysisDisabledAtom,
  getAnalysisGameAction,
  getAnalysisLimitAction,
} from '../../model';

type Props = {
  className?: string;
};

const AnalyzeButton: FC<Props> = ({ className }) => {
  const playerQuery = usePlayerQuery();
  const { Analytics } = useServices();

  const [analysisLimitStatus] = useAtom(getAnalysisLimitAction.statusesAtom);
  const [cgApi] = useAtom(cgApiAtom);
  const [game] = useAtom(getAnalysisGameAction.dataAtom);
  const [analysisDisabled, setDisabledAnalyze] = useAtom(analysisDisabledAtom);

  const getAnalysisLimit = useAction(getAnalysisLimitAction);
  const analysisStartDate = useAction(analysisStartDateAction);
  const analyze = useAction(analyzeGameAction);

  const { isOpen: isOpenLimitModal, open, close } = useModal();

  const loading = analysisLimitStatus.isPending || !game || !cgApi;

  const openLimitModal = () => {
    open();
    setDisabledAnalyze(true);
  };

  const closeLimitModal = () => {
    close();
    setDisabledAnalyze(false);
  };

  const tryAnalyze = async () => {
    Analytics.sendEvent(TAP_EVENTS.analyzeGame);

    if (hasVIP(playerQuery.data?.player)) {
      analyze();
      return;
    }

    const limitData = await getAnalysisLimit();

    if (limitData.date) {
      openLimitModal();
      return;
    }

    analysisStartDate({ date: new Date().toJSON() });
    analyze();
  };

  const adAnalyze = () => {
    setDisabledAnalyze(false);
    analysisStartDate({ adDate: new Date().toJSON() });
    analyze();
  };

  return (
    <>
      <Button
        loading={loading}
        disabled={loading || analysisDisabled}
        color="secondary"
        onClick={tryAnalyze}
        className={className}
        fullWidth
      >
        {t('button.analyze')}
      </Button>
      {isOpenLimitModal && (
        <AnalysisLimitModal isOpen={isOpenLimitModal} onRequestClose={closeLimitModal} onAdViewed={adAnalyze} />
      )}
    </>
  );
};

export default AnalyzeButton;
